import React from 'react';
import { PropTypes } from 'prop-types';
import StandardConfiguration from '../ExtraConfiguration/StandardConfiguration';
import NoExtraConfiguration from '../ExtraConfiguration/NoExtraConfiguration';

function ConnectionAttributes(props) {
  const { mainForm, handleChangeAttribute, handleEditAttributeAutoComplete } = props;
  const providerSelected = mainForm.values.connectionProvider;

  const loadAttributesComponents = () => {
    switch (providerSelected.toUpperCase()) {
      case 'SABRE':
      case 'HILTON':
        return (
          <StandardConfiguration
            mainForm={mainForm}
            handleChangeAttribute={handleChangeAttribute}
            handleEditAttributeAutoComplete={handleEditAttributeAutoComplete}
          />
        );
      default:
        return <NoExtraConfiguration />;
    }
  };

  return <div style={{ marginTop: '5%' }}>{loadAttributesComponents()}</div>;
}

ConnectionAttributes.propTypes = {
  mainForm: PropTypes.shape({
    values: {
      connectionProvider: PropTypes.string
    }
  }),
  handleChangeAttribute: PropTypes.func,
  handleEditAttributeAutoComplete: PropTypes.func
};

ConnectionAttributes.defaultProps = {
  mainForm: {},
  handleChangeAttribute: () => {},
  handleEditAttributeAutoComplete: () => {}
};

export default ConnectionAttributes;
